<template>
<!-- eslint-disable max-len -->
<edit-page
  name="Article"
  model-name="article"
  param="articleId"
  page-prefix="/blade/articles"
  :create="createArticle"
  :fetch="getArticle"
  :fetch-types="getArticleTypes"
  :update="updateArticle"
  :remove="deleteArticle"
  :enum-names="['articleCategories']"
  :stub="article"
  :validator="validator"
  :utils="utils">
<template slot-scope="{ model: article, enums: { articleCategories }, validator }">
  <text-input label v-model="article.title" :validator="validator.title" required autofocus>Title</text-input>

  <text-input label v-model="article.subtitle">Subtitle</text-input>

  <text-input label v-model="article.author">Author</text-input>

  <text-input label v-model="article.lastUpdatedOverride">Last Updated Override (uses edit timestamp by default)</text-input>

  <text-input label v-model="article.body" :validator="validator.body" required textarea>Body</text-input>

  <checkbox-input label v-model="article.appendTicketRequestButton">Append Contact Support Button</checkbox-input>

  <select-input
    label
    v-model="article.category"
    :options="articleCategories"
    use="_id"
    display="title"
    :to="(id) => { return `/blade/article-categories/${id}/edit`; }"
    :validator="validator.category"
    required
  >
    Category
  </select-input>
</template>
</edit-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import EditPage from '../../ui/pages/EditPage';

import CheckboxInput from '../../ui/inputs/CheckboxInput';
import SelectInput from '../../ui/inputs/SelectInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    EditPage,
    CheckboxInput,
    SelectInput,
    TextInput
  },
  data() {
    return {
      utils: {
      },
      article: {
        _id: '',
        title: '',
        subtitle: '',
        author: '',
        lastUpdatedOverride: '',
        body: '',
        appendTicketRequestButton: false,
        category: null,
      },
      validator: {
        title: { required },
        body: { required },
        category: { required },
      }
    };
  },
  methods: {
    ...mapActions([
      'getArticle',
      'getArticleTypes',
      'createArticle',
      'updateArticle',
      'deleteArticle',
    ])
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ArticleEdit.vue